export default __webpack_public_path__ + "static/media/section.3f5b5da6.png";